import { translateStatic } from '../translations';

export const CharacterTagTypesEnum = {
  SafeFlirt: 'SAFE_FLIRT',
  NSFW: 'NSFW',
  Realistic: 'REALISTIC',
  BDSM: 'BDSM',
  Roleplay: 'ROLEPLAY',
  Adventure: 'ADVENTURE',
  Bold: 'BOLD',
  Shy: 'SHY',
  Image_generation: 'IMAGE_GENERATION',
  Anime: 'ANIME',
};

export const CharacterTags = {
  [CharacterTagTypesEnum.SafeFlirt]: {
    id: CharacterTagTypesEnum.SafeFlirt,
    label: translateStatic('data_characters_tags:safe_flirt'),
  },
  [CharacterTagTypesEnum.NSFW]: {
    id: CharacterTagTypesEnum.NSFW,
    label: translateStatic('data_characters_tags:nsfw'),
  },
  [CharacterTagTypesEnum.Realistic]: {
    id: CharacterTagTypesEnum.Realistic,
    label: translateStatic('data_characters_tags:realistic'),
  },
  [CharacterTagTypesEnum.BDSM]: {
    id: CharacterTagTypesEnum.BDSM,
    label: translateStatic('data_characters_tags:bdsm'),
  },
  [CharacterTagTypesEnum.Roleplay]: {
    id: CharacterTagTypesEnum.Roleplay,
    label: translateStatic('data_characters_tags:roleplay'),
  },
  [CharacterTagTypesEnum.Adventure]: {
    id: CharacterTagTypesEnum.Adventure,
    label: translateStatic('data_characters_tags:adventure'),
  },
  [CharacterTagTypesEnum.Bold]: {
    id: CharacterTagTypesEnum.Bold,
    label: translateStatic('data_characters_tags:bold'),
  },
  [CharacterTagTypesEnum.Shy]: {
    id: CharacterTagTypesEnum.Shy,
    label: translateStatic('data_characters_tags:shy'),
  },
  [CharacterTagTypesEnum.Anime]: {
    id: CharacterTagTypesEnum.Anime,
    label: translateStatic('data_characters_tags:anime'),
  },
  [CharacterTagTypesEnum.Image_generation]: {
    id: CharacterTagTypesEnum.Image_generation,
    label: translateStatic('data_characters_tags:image_generation'),
  },
};
